import AutoComplete from 'js-autocomplete';
import { on, fire } from 'delegated-events';
import helpers from './helpers.js';

export default (function () {
  return {
    init() {
      const acInputs = document.querySelectorAll('.js-autocomplete');

      if (acInputs.length) {
        // stop enter press on autocomplete field
        on('keydown', '.js-autocomplete', (e) => {
          if (e.keyCode === 13) {
            e.preventDefault();
            e.target.blur();
            e.stopPropagation();
          }
        });

        helpers.forEach(acInputs, (i, el) => {
          const ac = new AutoComplete({
            selector: el,
            minChars: 3,
            source(term, suggest) {
              // In page JSON
              // const newTerm = term.toLowerCase();
              // const choices = window[el.getAttribute('data-ac-var')];
              // const matches = [];
              // for (let n = 0; n < choices.length; n++) {
              //   if (choices[n].name.toLowerCase().indexOf(newTerm) >= 0) {
              //     matches.push(choices[n]);
              //   }
              // }
              // suggest(matches);

              // URL Based
              const url = `${el.getAttribute('data-ac-url')}/${term}`;
              const noRes = el.getAttribute('data-no-results') || 'No results';

              fetch(url, {
                method: 'GET',
              }).then(response => response.json()).then((json) => {
                if (json.length) {
                  suggest(json);
                } else {
                  suggest([{
                    title: noRes,
                    empty: true,
                  }]);
                }
              });
            },
            onSelect(event, term, item) {
              const url = item.getAttribute('data-url');
              const id = item.getAttribute('data-id');
              if (url != null && url !== '') {
                window.location = url;
              }

              if (id != null && id !== '') {
                const fieldId = el.getAttribute('data-field');
                if (fieldId != null && fieldId !== '') {
                  const field = document.querySelector(`#${fieldId}`);
                  field.value = id;
                  fire(field, 'change');
                }
              }
            },
            renderItem(item, search) {
              if (item.empty) {
                return `<div class="autocomplete-suggestion autocomplete-no-results">${item.title}</div>`;
              }

              const newItem = item.title;
              const newSearch = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
              const re = new RegExp(`(${newSearch.split(' ').join('|')})`, 'gi');
              const redirect = el.getAttribute('data-redirect') === 'true';
              return `<div class="autocomplete-suggestion" data-id="${item.id}" data-val="${newItem}" ${redirect && item.url ? `data-url="${item.url}"` : ''}>${newItem.replace(re, '<b>$1</b>')}</div>`;
            },
          });
        });
      }
    },
  };
}());
